import { auth } from '../firebase';
import { buildApiUrl } from '../config/env';

const getAuthHeaders = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('User must be authenticated to manage workspaces');
  }

  const authToken = await currentUser.getIdToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${authToken}`,
  };
};

const parseError = async (response, fallback) => {
  try {
    const body = await response.json();
    return body?.error || fallback;
  } catch (error) {
    return fallback;
  }
};

export const createProject = async ({ name, description = '', instructions = '' }) => {
  const response = await fetch(buildApiUrl('/projects'), {
    method: 'POST',
    headers: await getAuthHeaders(),
    body: JSON.stringify({ name, description, instructions }),
  });

  if (!response.ok) {
    throw new Error(await parseError(response, 'Failed to create workspace'));
  }

  return response.json();
};

export const listProjects = async () => {
  const response = await fetch(buildApiUrl('/projects'), {
    method: 'GET',
    headers: await getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error(await parseError(response, 'Failed to load workspaces'));
  }

  return response.json();
};

export const updateProject = async ({ projectId, name, description = '', instructions = '' }) => {
  const response = await fetch(buildApiUrl(`/projects/${projectId}`), {
    method: 'PUT',
    headers: await getAuthHeaders(),
    body: JSON.stringify({ name, description, instructions }),
  });

  if (!response.ok) {
    throw new Error(await parseError(response, 'Failed to update workspace'));
  }

  return response.json();
};

export const deleteProject = async (projectId) => {
  const response = await fetch(buildApiUrl(`/projects/${projectId}`), {
    method: 'DELETE',
    headers: await getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error(await parseError(response, 'Failed to delete workspace'));
  }

  return response.json();
};

export const moveChatToProject = async ({ chatId, projectId = null }) => {
  const response = await fetch(buildApiUrl(`/chats/${chatId}/project`), {
    method: 'POST',
    headers: await getAuthHeaders(),
    body: JSON.stringify({ projectId }),
  });

  if (!response.ok) {
    throw new Error(await parseError(response, 'Failed to move chat'));
  }

  return response.json();
};
